<template>
<CCard>
  <CCardHeader>
    <h2>部署更新</h2>
  </CCardHeader>
  <CCardBody>
    <CRow v-if="message.length">
      <ul>
        <li class="preika-form-message" v-for="error in message" :key="error">{{ error }}</li>
      </ul>
    </CRow>

    <CRow v-if="items">
      <CCol sm="4">
        <label>部署名<span class="asterisk">*</span></label>
        <CInput v-model="items.name" maxlength="60" />
      </CCol>
    </CRow>

    <CRow v-if="items">
      <CCol sm="4">
        <label>部署コード</label>
        <CInput v-model="items.code" maxlength="30" />
      </CCol>
    </CRow>

    <CRow v-if="items">
      <CCol sm="4">
        <label>親部署</label>
        <select class="custom-select" v-model="items.parent_id">
          <option :value="''">未設定</option>
          <option v-for="option in parentOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </CCol>
    </CRow>

    <CRow v-if="items">
      <CCol sm="4">
        <label>部署長</label>
        <select class="custom-select" v-model="items.head_user_id">
          <option :value="''">未設定</option>
          <option v-for="option in headUserOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </CCol>
    </CRow>

    <CRow v-if="items">
      <CCol sm="2">
        <label>並び優先度</label>
        <CInput type="number" v-model="items.order_level" />
      </CCol>
    </CRow>

    <CRow v-if="items">
      <CCol sm="6">
        <label>備考</label>
        <CTextarea v-model="items.remarks" rows="3" maxlength="100" />
      </CCol>
    </CRow>

    <br>

    <CRow class="mt-3 align-items-center" v-if="items">
      <CCol class="text-start">
        <button class="btn btn-secondary" @click="valueCheck">戻る</button>
      </CCol>
      <CCol class="text-center">
        <button v-on:click="openModal" class="btn btn-info" :disabled="!items.name">確認</button>
        <UpdateModal
          :name="items.name"
          :code="items.code"
          :parent_name="selectedParentName"
          :head_user_name="selectedHeadUserName"
          :order_level="orderLevelNumber"
          :remarks="items.remarks"
          :loading="loading"
          v-show="showModal"
          @update="update"
          @close="closeModal"
        />
      </CCol>
      <CCol></CCol>
    </CRow>
  </CCardBody>
</CCard>
</template>

<script>
import ConstList from './../ConstList'
import UpdateModal from './UpdateModal'
import axios from 'axios'

export default {
  name: 'DepartmentUpdateInput',
  components: { UpdateModal },
  data() {
    return {
      showModal: false,
      items: null,
      parentOptions: [],
      headUserOptions: [],
      message: [],
      id: '',
      loading: false
    }
  },
  mounted: function () {
    this.id = this.$route.params.id
    const id = parseInt(this.id)

    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/departments/' + id)
      .then((response) => {
        this.items = response.data
        if (this.items.parent_id == null) this.items.parent_id = ''
        if (this.items.head_user_id == null) this.items.head_user_id = ''
      })
      .catch((error) => {
        axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => alert(ConstList.SYSTEM_ERROR))
          .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR))
      })

    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/departments/options/parents', { params: { excludeId: id } })
      .then((response) => {
        this.parentOptions = response.data
      })
      .catch((error) => {
        axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => alert(ConstList.SYSTEM_ERROR))
          .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR))
      })

    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/departments/options/head-users')
      .then((response) => {
        this.headUserOptions = response.data
      })
      .catch((error) => {
        axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => alert(ConstList.SYSTEM_ERROR))
          .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR))
      })
  },
  computed: {
    orderLevelNumber() {
      if (!this.items) return 0
      const n = Number(this.items.order_level)
      return Number.isFinite(n) ? n : 0
    },
    selectedParentName() {
      if (!this.items) return ''
      const row = this.parentOptions.find(({ id }) => String(id) === String(this.items.parent_id))
      return row ? row.name : ''
    },
    selectedHeadUserName() {
      if (!this.items) return ''
      const row = this.headUserOptions.find(({ id }) => String(id) === String(this.items.head_user_id))
      return row ? row.name : ''
    }
  },
  methods: {
    valueCheck: function () {
      if (confirm(ConstList.TRANSITION)) {
        this.$router.push({
          name: ConstList.DEPARTMENT_ROUTE_INFO,
          params: { id: this.$route.params.id }
        })
      }
    },
    openModal: function () {
      this.showModal = true
    },
    closeModal: function () {
      this.showModal = false
    },
    update: function () {
      this.loading = true
      const params = new URLSearchParams()
      params.append('name', this.items.name)
      params.append('code', this.items.code || '')
      params.append('parent_id', this.items.parent_id === '' ? '' : Number(this.items.parent_id))
      params.append('head_user_id', this.items.head_user_id === '' ? '' : Number(this.items.head_user_id))
      params.append('order_level', this.orderLevelNumber)
      params.append('remarks', this.items.remarks || '')

      const id = parseInt(this.$route.params.id)
      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/departments/' + id, params)
        .then((response) => {
          if (response.data === ConstList.SUCCESS) {
            alert(ConstList.REGISTER_MESSAGE)
            this.showModal = false
            this.$router.push({ name: ConstList.DEPARTMENT_ROUTE_LIST })
          } else {
            this.message = [response.data]
            this.showModal = false
          }
        })
        .catch((error) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: error.message || String(error) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR))
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.asterisk { color: red; }
button:disabled { cursor: not-allowed; }
</style>
